import React, { useState, useContext, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";

import styles from "./footer.module.css";
import { useSidebarContext } from "../Context";
import { AuthContext } from "../../../../../context";

const Profile = () => {
  const { isSidebarCollapsed } = useSidebarContext();
  const [isProfileMenuActive, setIsProfileMenuActive] = useState(false);

  const profileMenuRef = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If click is outside both footer and profile menu, close it
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target) &&
        footerRef.current &&
        !footerRef.current.contains(event.target)
      ) {
        setIsProfileMenuActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleProfileMenu = () => {
    setIsProfileMenuActive((prev) => !prev);
  };

  const getFullName = (maxLength) => {
    const firstName = localStorage.getItem("FirstName")?.trim() || "";
    const lastName = localStorage.getItem("LastName")?.trim() || "";
    const fullName = `${firstName} ${lastName}`.trim();

    if (maxLength && fullName.length > maxLength) {
      return fullName.slice(0, maxLength).trim() + "...";
    }

    return fullName;
  };

  const getEmail = () => {
    return localStorage.getItem("emailId") || "";
  };

  return (
    <footer
      ref={footerRef}
      className={`${styles.footer_container} ${
        isSidebarCollapsed ? styles.collpased : ""
      }`}
      onClick={toggleProfileMenu}
    >
      <div className={styles.profile_info_container}>
        <img
          src="/icon_profile.svg"
          alt=""
          className={`${styles.profile_pic} `}
        />
        {!isSidebarCollapsed && (
          <div className={styles.profile_info}>
            <h3>{getFullName(20)}</h3>
            <span>Account</span>
          </div>
        )}
      </div>
      {!isSidebarCollapsed && (
        <FontAwesomeIcon
          icon={faEllipsisV}
          className={styles.profile_options_icon}
        />
      )}

      {isProfileMenuActive && (
        <ProfileMenu
          fullName={getFullName(20)}
          email={getEmail()}
          ref={profileMenuRef}
        />
      )}
    </footer>
  );
};

export default Profile;

const ProfileMenu = React.forwardRef(({ fullName = "", email = "" }, ref) => {
  const authContext = useContext(AuthContext);
  return (
    <div
      ref={ref}
      className={`${styles.profile_container} ${styles.profile_menu}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.profile_info_container}>
        <img src="/icon_profile.svg" alt="" className={styles.profile_pic} />
        <div className={styles.profile_menu_info}>
          <h3>{fullName}</h3>
          <span>{email}</span>
        </div>
      </div>
      <div className={styles.logout_container}>
        <button
          className={styles.logout_text}
          onClick={() => authContext.logout()}
        >
          <FontAwesomeIcon icon={faArrowRightFromBracket} /> Logout
        </button>
      </div>
    </div>
  );
});
